import { useState, useEffect, useCallback } from 'react'
import { apiRankList } from '../server/ServiceCall'

interface RankEntry {
  rank:         number
  userName:     string
  mugongStage:  string
  totalPower:   number
  atk:          number
  def:          number
  speed:        number
  turnCount:    number
  currentRegion:string
  sectName:     string | null
}

const REGION_KO: Record<string, string> = {
  RGN_HONAM:'호남', RGN_JIRIM:'지림', RGN_SANDO:'산동', RGN_NAKYANG:'낙양',
  RGN_BUKDO:'북도', RGN_NANDO:'남도', RGN_DAEMO:'대막', RGN_HUASHAN:'화산',
  RGN_ZHONGYUAN:'중원', RGN_WUDANG:'무당산', RGN_SHAOLIN:'소림사', RGN_DALI:'대리국',
  RGN_XIYUE:'서역', RGN_SICHUAN:'사천', RGN_MINGGU:'광명정', RGN_JANGBACK:'장백산',
  RGN_TIBET:'서장', RGN_JIANGNAN:'강남', RGN_TOEI:'동영', RGN_HAEDONG:'해동',
}
const STAGE_COLOR: Record<string, string> = {
  '三流':'#a0a0a0','二流':'#60c060','一流':'#4090e0','絶頂':'#a060e0','花境':'#e0a030','玄境':'#e04060','生死境':'#ff6080',
}

export default function TabRank() {
  const [ranks,   setRanks]   = useState<RankEntry[]>([])
  const [loading, setLoading] = useState(false)

  const load = useCallback(() => {
    setLoading(true)
    apiRankList(50)
      .then(res => {
        if (res.resultCode === '00') {
          const raw = JSON.parse(res.resultData || '[]') as any[]
          setRanks(raw.map((r, i) => ({
            rank:          i + 1,
            userName:      String(r.USER_NAME),
            mugongStage:   String(r.MUGONG_STAGE),
            totalPower:    Number(r.TOTAL_POWER) || 0,
            atk:           Number(r.ATK)        || 0,
            def:           Number(r.DEF)        || 0,
            speed:         Number(r.SPEED)      || 0,
            turnCount:     Number(r.TURN_COUNT) || 0,
            currentRegion: String(r.CURRENT_REGION ?? ''),
            sectName:      r.SECT_NAME ? String(r.SECT_NAME) : null,
          })))
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [])

  useEffect(() => { load() }, [load])

  return (
    <div className="tab-action">
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:8 }}>
        <div className="card-title" style={{ margin:0 }}>무림 고수 순위</div>
        <button className="action-btn equip" style={{ padding:'4px 10px', fontSize:11 }}
          onClick={load} disabled={loading}>새로고침</button>
      </div>

      {loading ? (
        <div style={{ color:'#605040', textAlign:'center', padding:'30px 0' }}>불러오는 중...</div>
      ) : ranks.length === 0 ? (
        <div className="bag-empty">랭킹 정보가 없습니다.</div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
          {ranks.map(r => (
            <div key={r.rank} style={{
              background:'#1a1208', border:'1px solid #3a2a18',
              borderRadius:4, padding:'8px 10px',
              display:'flex', alignItems:'center', gap:8,
            }}>
              <div style={{
                width:28, textAlign:'center', fontWeight:'bold', fontSize:13,
                color: r.rank === 1 ? '#ffd700' : r.rank === 2 ? '#c0c0c0' : r.rank === 3 ? '#cd7f32' : '#606050',
              }}>
                {r.rank}
              </div>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                  <span style={{ fontWeight:'bold', fontSize:13, color:'#c8b890' }}>{r.userName}</span>
                  <span style={{ fontSize:11, color: STAGE_COLOR[r.mugongStage] ?? '#a0a0a0' }}>
                    {r.mugongStage}
                  </span>
                  {r.sectName && (
                    <span style={{ fontSize:10, color:'#8a7a4a', border:'1px solid #5a4a20',
                      padding:'0 3px', borderRadius:2 }}>{r.sectName}</span>
                  )}
                </div>
                <div style={{ fontSize:10, color:'#706050', marginTop:2 }}>
                  공 {r.atk} · 방 {r.def} · 속 {r.speed} · {REGION_KO[r.currentRegion] ?? r.currentRegion}
                </div>
              </div>
              <div style={{ textAlign:'right', flexShrink:0 }}>
                <div style={{ color:'#e0c040', fontWeight:'bold', fontSize:13 }}>
                  {r.totalPower.toLocaleString()}
                </div>
                <div style={{ fontSize:10, color:'#706050' }}>전투력</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
